import { render, staticRenderFns } from "./videodata.vue?vue&type=template&id=24a72bf4&scoped=true&"
import script from "./videodata.vue?vue&type=script&lang=js&"
export * from "./videodata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a72bf4",
  null
  
)

export default component.exports